export default __webpack_public_path__ + "locales/fr/MainBar.json?hash=da934c18f5733f1918f688057157dbc4";